import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { getMetricName } from 'utils/metrics';
import * as widgetTypes from '../../utils/dashboardWidgetTypes';
import { getWidgetMetric, getWidgetType } from '../../utils/dashboardWidgetUtils';

// type Props = {
//   /** Header text for delete modal. */
//   header: string,
//   /** Callback function to delete widget when close is click. */
//   onClose: () => void,
//   /** Callback function to delete widget when comfirm is click. */
//   onDelete: () => void,
//   /** The selected widget to delete. */
//   selectedWidget: {},
// };

const getWidgetName = (selectedWidget) => {
  switch (getWidgetType(selectedWidget)) {
    case widgetTypes.CAMPAIGNS_TABLE:
      return 'Campaigns Table';
    default:
      return selectedWidget.name || getMetricName(getWidgetMetric(selectedWidget));
  }
};

export const DELETE_MODAL_TEST_ID = 'delete-dashboard-widget-modal';
export const DELETE_BUTTON_TEST_ID = 'delete-dashboard-widget-modal-delete-button';

const DeleteModal = ({
  header = 'Delete widget?',
  onClose = () => {},
  onDelete = () => {},
  selectedWidget = {},
}) => {
  return (
    <Modal
      data-test={DELETE_MODAL_TEST_ID}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>{header}</ModalHeader>
      <ModalBody>
        Are you sure you want to delete <strong>{getWidgetName(selectedWidget)}</strong>? This
        cannot be undone.
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          size={BUTTON_SIZES.LARGE}
          data-test={DELETE_BUTTON_TEST_ID}
          onClick={() => onDelete(selectedWidget.id)}
        >
          Delete widget
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
